import { render, staticRenderFns } from "./form.vue?vue&type=template&id=11d2ec34&scoped=true&lang=pug&"
import script from "./form.vue?vue&type=script&setup=true&lang=js&"
export * from "./form.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=11d2ec34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d2ec34",
  null
  
)

export default component.exports